import { render, staticRenderFns } from "./pendingApplyActivitiesTraineeComp.vue?vue&type=template&id=3570b712"
import script from "./pendingApplyActivitiesTraineeComp.vue?vue&type=script&lang=js"
export * from "./pendingApplyActivitiesTraineeComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports